import cloudronLogo from '#app/assets/partner-logos/cloudron.png'
import electrojoulelogo from '#app/assets/partner-logos/electrojoule.svg'
import kmufamilieLogo from '#app/assets/partner-logos/kmufamilie.png'
import revoltarisLogo from '#app/assets/partner-logos/revoltaris.png'
import spielseitigLogo from '#app/assets/partner-logos/spielseitig.png'
import xiquellLogo from '#app/assets/partner-logos/xiquell.svg'
import { cn } from '#app/utils/misc.tsx'

export type PartnerLogo = {
	/** Stable key, also the locale key of a Referenz sentence */
	id: string
	name: string
	logo: string
	url: string
	/** See Kunde and Partner in CONTEXT.md */
	kind: 'kunde' | 'partner'
	/** Icon-heavy logos keep shape with grayscale instead of brightness-0 */
	iconLogo?: boolean
}

export const partners = [
	{
		id: 'cloudron',
		name: 'Cloudron',
		logo: cloudronLogo,
		url: 'https://www.cloudron.io/',
		kind: 'partner',
		iconLogo: true,
	},
	{
		id: 'revoltaris',
		name: 'Revoltaris',
		logo: revoltarisLogo,
		url: 'https://revoltaris.ch/',
		kind: 'partner',
	},
	{
		id: 'electrojoule',
		name: 'Electrojoule',
		logo: electrojoulelogo,
		url: 'https://electrojoule.ch/',
		kind: 'kunde',
		iconLogo: true,
	},
	{
		id: 'spielseitig',
		name: 'Spielseitig',
		logo: spielseitigLogo,
		url: 'https://spielseitig.ch/',
		kind: 'partner',
		iconLogo: true,
	},
	{
		id: 'kmu-familie',
		name: 'KMU Familie',
		logo: kmufamilieLogo,
		url: 'https://kmufamilie.ch/',
		kind: 'partner',
	},
	{
		id: 'xiquell',
		name: 'Xiquell',
		logo: xiquellLogo,
		url: 'https://xiquell.ch/',
		kind: 'kunde',
	},
] as const satisfies readonly PartnerLogo[]

/** The ids of the Kunde entries: the only candidates for a Referenz. */
export type KundeId = Extract<
	(typeof partners)[number],
	{ kind: 'kunde' }
>['id']

/**
 * A partner or customer logo rendered monochrome, inverted in dark mode. The
 * `group-hover` classes only take effect inside a `group` such as the logo
 * link that renders it; elsewhere the logo stays monochrome. A `lit`
 * logo shows its colours without a hover, as the LogoSpotlight's active one.
 */
export function PartnerLogoImage({
	partner,
	lit = false,
}: {
	partner: PartnerLogo
	lit?: boolean
}) {
	return (
		<img
			src={partner.logo}
			alt={partner.name}
			className={cn(
				'max-h-10 max-w-32 w-auto object-contain transition-all duration-300 group-hover:grayscale-0 dark:invert dark:group-hover:invert-0',
				partner.iconLogo
					? 'grayscale'
					: 'brightness-0 group-hover:brightness-100',
				lit && 'brightness-100 grayscale-0 dark:invert-0',
			)}
		/>
	)
}
